import React, { useState, useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"
import { withStyles } from "@material-ui/core/styles"
import styles from "./styles"
import {
  Box,
  Button,
  Typography,
  Avatar,
  FormControl,
  MenuItem,
  Select,
  // CircularProgress,
  IconButton,
  Tooltip
} from "@material-ui/core/"
import AddAPhotoIcon from "@material-ui/icons/AddAPhoto"
import InfoIcon from "@material-ui/icons/Info"
import Dropzone from "react-dropzone"
import { Formik, Form } from "formik"
import * as Yup from "yup"
import ReusableFormControl from "../../../../../components/ReusableFormControl"
import { ChromePicker } from "react-color"
import AddCircleRoundedIcon from "@material-ui/icons/AddCircleRounded"
import { openAddNewFieldDialog } from "actions/add-new-field-dialog"
// import fixOrientation from "fix-orientation"
import cloudinary from "cloudinary-core"
import MaskedMobileInput from "components/MaskedMobileInput"
import GooglePlacesAutocomplete from "react-google-places-autocomplete"
import { updateOrganization } from "actions/organization"
import formatString from "format-string-by-pattern"
import EditIcon from "@material-ui/icons/Edit"
import { openSnackBar } from "actions/snack-bar"
import { resizeImage } from "actions/upload"
import { geocodeByPlaceId } from "react-google-places-autocomplete/dist/utils/googleGeocodesHelper"
import { openDeleteOrgDialog } from "actions/delete-org-dialog"
import { useRef } from "react"
import PostSettings from "components/SideBox/components/PostSettings"
import IntegrationConnections from "../IntegrationConnections"

const extractFromAddress = (components, type, part = "long_name") => {
  for (var i = 0; i < components.length; i++) {
    for (var j = 0; j < components[i].types.length; j++) {
      if (components[i].types[j] === type) return components[i][part]
    }
  }
  return ""
}

const cl = new cloudinary.Cloudinary({
  cloud_name: process.env.REACT_APP_CLOUD_NAME
})

const settingsFields = [
  {
    name: "phone",
    label: "Organization Phone",
    inputProps: {
      inputComponent: MaskedMobileInput
    }
  },
  {
    name: "email",
    label: "Organization Email"
  }
]

const RegisterSchema = Yup.object().shape({
  name: Yup.string().required("Required"),
  shortName: Yup.string()
    .required("Required")
    .max(12, "Max: 12 characters"),
  phone: Yup.string()
    .required("Required")
    .length(14, "Please enter a mobile phone number"),
  email: Yup.string()
    .email("Invalid email")
    .required("Required"),
  address: Yup.string().required("Required")
})

const reader = new FileReader()

const IntergrationTextFields = ({ classes, org, setCardInfo, isMobile }) => {
  const dispatch = useDispatch()
  const { authenticatedUser, defaultTitleFieldId } = useSelector(state => ({
    authenticatedUser: state.authentication.authenticatedUser,
    defaultTitleFieldId: state.organization.currentOrg.title_field_id
  }))
  const {
    first_name: firstName,
    last_name: lastName,
    profile_image: profileImage
  } = authenticatedUser
  const [background, setBackground] = useState("#001F54")
  const [addressTouched, setAddressTouched] = useState(false)
  const [initialAddress, setInitialAddress] = useState(
    JSON.parse(org.address).address
  )
  const formRef = useRef(null)
  // const [openCustomizeOrganization, setOpenCustomizeOrganization] = useState(
  //   false
  // )

  const [settingsUpdate, setSettingsUpdate] = useState(false)
  // const [titleFieldId, setTitleFieldId] = useState(
  //   org.additionalFields &&
  //     org.additionalFields.length > 0 &&
  //     org.title_field_id !== null
  //     ? org.additionalFields.find(x => x.id === org.title_field_id).id
  //     : -1
  // )
  const [titleFieldId, setTitleFieldId] = useState(defaultTitleFieldId)
  let logo = null
  if (org && org.logo) {
    try {
      logo = JSON.parse(org.logo).public_id
    } catch (error) {
      logo = null
    }
  }

  useEffect(() => {
    setTitleFieldId(defaultTitleFieldId)
  }, [defaultTitleFieldId])

  const handleChangeSelect = e => {
    let titleFieldId = null
    setTitleFieldId(e.target.value)

    if (e.target.value === -1) {
      titleFieldId = null
    } else {
      titleFieldId = e.target.value
    }

    dispatch(updateOrganization({ title_field_id: titleFieldId }, org.id))
      .then(() => {
        dispatch(openSnackBar({ message: "User title updated." }))
      })
      .catch(() => {
        dispatch(openSnackBar({ message: "Error updating user title." }))
      })
  }

  const handleOpenAdditionalFields = () => {
    dispatch(openAddNewFieldDialog())
  }

  const handleOpenAdditionalFieldsFromEdit = field => {
    dispatch(openAddNewFieldDialog(field))
  }

  const handleSubmit = values => {
    setSettingsUpdate(true)
    const newValues = Object.assign({}, values)
    // only update short name if one was selected
    if (newValues.shortName) {
      newValues.short_name = newValues.shortName
      delete newValues.shortName
    }

    // only update address if one was selected
    if (newValues.location) {
      newValues.address = newValues.location
    } else {
      delete newValues.address
    }
    dispatch(updateOrganization({ ...newValues, currentLogo: logo }, org.id))
      .then(() => {
        setSettingsUpdate(false)
        setAddressTouched(false)
        dispatch(openSnackBar({ message: "Updated organization settings" }))
      })
      .catch(() => {
        dispatch(
          openSnackBar({ message: "Error updating organization settings" })
        )
      })
  }

  const titleField = org.additionalFields.find(x => x.id === titleFieldId)

  const getTitleFieldName = titleFieldId => {
    const match = org.additionalFields.find(x => x.id === titleFieldId)
    if (match) {
      return match.name
    }
  }

  const [displayColorPicker, setDisplayColorPicker] = useState(false)

  const handleClickPicker = () => {
    setDisplayColorPicker(!displayColorPicker)
  }

  const handleClosePicker = () => {
    setDisplayColorPicker(false)
  }

  // let initalAddress = ""
  // if (org.address) {
  //   try {
  //     initalAddress = JSON.parse(org.address).address
  //   } catch (err) {
  //     console.log(err)
  //   }
  // }
  // console.log(initalAddress)

  return (
    <Box className={classes.settingsContainer}>
      <Formik
        initialValues={{
          name: org.name ? org.name : "",
          shortName: org.short_name ? org.short_name : "",
          logo: logo,
          phone: org.phone
            ? formatString("(000) 000-0000", org.phone.replace("+1", ""))
            : "",
          email: org.email ? org.email : "",
          address: initialAddress,
          brand_theme: org.brand_theme ? org.brand_theme : "#001F54"
        }}
        validationSchema={RegisterSchema}
        onSubmit={(values, { setSubmitting }) => {
          handleSubmit(values)
          setSubmitting(false)
        }}
        innerRef={formRef}
      >
        {formikProps => (
          <Form>
            <Box>
              <Box
                className={classes.LogoCustomizedColorContainer}
                display="flex"
                flexWrap="wrap"
              >
                <Box className={classes.organizationPictureContainer}>
                  <Typography
                    className={classes.organizationLogoTitle}
                    variant="h5"
                  >
                    Organization Logo
                  </Typography>
                  <Box className={classes.avatarContainer}>
                    <Avatar
                      className={classes.image}
                      src={
                        /* eslint-disable */
                        formikProps.values.logo &&
                        formikProps.values.logo.split("/")[0] === "organization"
                          ? cl.url(formikProps.values.logo, {
                              width: 400,
                              crop: "scale"
                            })
                          : formikProps.values.logo
                        /* eslint-enable */
                      }
                    />
                    <Dropzone
                      onDrop={acceptedFiles => {
                        const file = acceptedFiles[0]
                        if (file !== undefined) {
                          // Set read as data url from uploaded file
                          reader.readAsDataURL(file)
                        }

                        reader.addEventListener("load", e => {
                          // fixOrientation(
                          //   reader.result,
                          //   { image: true },
                          //   function(fixed, image) {
                          dispatch(resizeImage(reader.result, 500, 500))
                            .then(res => {
                              formikProps.setFieldValue("logo", res)
                              formikProps.handleSubmit()
                            })
                            .catch(error =>
                              dispatch(
                                openSnackBar({
                                  message: "Image failed to upload."
                                })
                              )
                            )
                          //     }
                          //   )
                        })
                      }}
                    >
                      {({ getRootProps, getInputProps }) => (
                        <section className={classes.addImageContainer}>
                          <div {...getRootProps()}>
                            <Button>
                              <input
                                {...getInputProps()}
                                accept="image/jpeg,image/jpg,image/png,application/pdf,image/x-eps,.svg"
                              />
                              <AddAPhotoIcon className={classes.iconColor} />
                            </Button>
                          </div>
                        </section>
                      )}
                    </Dropzone>
                  </Box>
                </Box>
                <Box
                  display="flex"
                  alignItems="center"
                  flexDirection="column"
                  className={classes.customizedColorContainer}
                >
                  <Typography
                    variant="h5"
                    className={classes.customizeColorsTitle}
                  >
                    Customize Organization Colors
                  </Typography>
                  <Box className={classes.mainColorBlockPickerContainer}>
                    <Box display="flex" className={classes.mainColorContainer}>
                      <Box>
                        <Typography variant="h5" className={classes.mainText}>
                          Main
                        </Typography>
                      </Box>
                      <Box>
                        <Box>
                          <Button
                            disableRipple
                            className={classes.ColorBox}
                            style={{
                              background: formikProps.values.brand_theme
                            }}
                            onClick={handleClickPicker}
                          >
                            {" "}
                          </Button>
                          {displayColorPicker ? (
                            <Box className={classes.popover}>
                              <Box
                                className={classes.cover}
                                onClick={() => {
                                  handleClosePicker()
                                  if (
                                    formikProps.initialValues.brand_theme !==
                                    formikProps.values.brand_theme
                                  ) {
                                    formikProps.handleSubmit()
                                  }
                                }}
                              />
                              <ChromePicker
                                disableAlpha
                                color={background}
                                onChangeComplete={value => {
                                  setBackground(value)
                                  formikProps.setFieldValue(
                                    "brand_theme",
                                    value.hex
                                  )
                                }}
                              />
                            </Box>
                          ) : null}
                        </Box>
                      </Box>
                      <Box>
                        <Typography
                          variant="h6"
                          className={classes.textColorContainer}
                        >
                          {formikProps.values.brand_theme}
                        </Typography>
                      </Box>
                      <Box>
                        <Button
                          className={classes.resetButton}
                          onClick={() => {
                            setBackground("#001F54")
                            formikProps.setFieldValue("brand_theme", "#001F54")

                            formikProps.handleSubmit()
                          }}
                        >
                          Reset
                        </Button>
                      </Box>
                    </Box>
                  </Box>
                </Box>
              </Box>
              <Box
                display="flex"
                justifyContent="space-between"
                className={classes.phoneEmailContainer}
              >
                <Box className={classes.nameShortName}>
                  <ReusableFormControl
                    name="name"
                    label="Organization Name"
                    formikProps={formikProps}
                    inputLabelClass={classes.labelTextColor}
                    isSettings
                  />
                </Box>
                <Box className={classes.nameShortName}>
                  <ReusableFormControl
                    name="shortName"
                    label="App Name"
                    formikProps={formikProps}
                    inputLabelClass={classes.labelTextColor}
                    isSettings
                  />
                  <Tooltip
                    title="This is the name of the app when downloaded. 12 characters max."
                    placement="top"
                  >
                    <InfoIcon className={classes.infoIcon} />
                  </Tooltip>
                  <Box>
                    <Box>
                      <Typography
                        className={
                          12 - formikProps.values.shortName.length >= 0
                            ? classes.greenCounter
                            : classes.redCounter
                        }
                      >
                        {12 - formikProps.values.shortName.length}
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              </Box>
              <Box
                display="flex"
                justifyContent="space-between"
                className={classes.phoneEmailContainer}
              >
                {settingsFields.map((field, i) => {
                  const { name, label, inputProps = {} } = field
                  return (
                    <Box className={classes.phoneEmail} key={i}>
                      <ReusableFormControl
                        name={name}
                        label={label}
                        formikProps={formikProps}
                        inputProps={inputProps}
                        inputLabelClass={classes.labelTextColor}
                        isSettings
                      />
                    </Box>
                  )
                })}
              </Box>
              <Box className={classes.address}>
                <FormControl
                  error={
                    !!(
                      formikProps.errors.location &&
                      formikProps.touched.location
                    )
                  }
                  className={classes.locationControl}
                >
                  <GooglePlacesAutocomplete
                    placeholder=""
                    suggestionsClassNames={{
                      container: classes.locationSuggestionContainer,
                      suggestion: classes.locationSuggestion,
                      suggestionActive: classes.locationSuggestionActive
                    }}
                    loader={<div style={{ display: "none" }} />}
                    onSelect={place => {
                      let placeObj = {
                        address: place.description,
                        placeId: place.place_id,
                        city: null,
                        state: null,
                        zip: null,
                        country: null,
                        street: null
                      }
                      geocodeByPlaceId(place.place_id)
                        .then(results => {
                          const streetNumber = extractFromAddress(
                            results[0].address_components,
                            "street_number"
                          )
                          const route = extractFromAddress(
                            results[0].address_components,
                            "route"
                          )
                          const city = extractFromAddress(
                            results[0].address_components,
                            "locality"
                          )
                          const state = extractFromAddress(
                            results[0].address_components,
                            "administrative_area_level_1",
                            "short_name"
                          )
                          const zip = extractFromAddress(
                            results[0].address_components,
                            "postal_code"
                          )
                          const country = extractFromAddress(
                            results[0].address_components,
                            "country"
                          )

                          const place = {
                            street: `${streetNumber} ${route}`,
                            city,
                            state,
                            zip,
                            country
                          }
                          placeObj = { ...placeObj, ...place }
                        })
                        .catch(err => {
                          console.log(err)
                        })
                        .finally(() => {
                          formikProps.setFieldValue(
                            "location",
                            JSON.stringify(placeObj)
                          )
                          formikProps.handleSubmit()
                        })
                    }}
                    renderInput={props => {
                      // set address to correct value
                      if (
                        initialAddress &&
                        props.value === "" &&
                        !addressTouched
                      ) {
                        props.value = initialAddress
                      }
                      return (
                        <ReusableFormControl
                          name="address"
                          label="Address"
                          formikProps={formikProps}
                          inputLabelClass={classes.labelTextColor}
                          inputProps={{
                            onKeyUp: e => {
                              formikProps.setFieldValue(
                                "address",
                                e.target.value
                              )
                              setAddressTouched(true)
                            },
                            ...props
                          }}
                        />
                      )
                    }}
                  />
                </FormControl>
              </Box>
              {initialAddress && (
                <Box
                  style={{ width: "100%" }}
                  display="flex"
                  justifyContent="center"
                >
                  <iframe
                    className={classes.map}
                    title="city-zone"
                    id="gmap_canvas"
                    src={`https://maps.google.com/maps?q=${initialAddress}&t=&z=13&ie=UTF8&iwloc=&output=embed`}
                    scrolling="no"
                    frameBorder="0"
                  />
                </Box>
              )}
              {/* <Box
                className={classes.buttonsContainer}
                display="flex"
                justifyContent="flex-end"
              >
                {settingsUpdate === false ? (
                  <Button type="submit" variant="contained" color="primary">
                    Update
                  </Button>
                ) : (
                  <Box className={classes.updateButton}>
                    <CircularProgress color="primary" />
                  </Box>
                )}
              </Box> */}
            </Box>
          </Form>
        )}
      </Formik>

      <Box
        display="flex"
        justifyContent="space-between"
        flexWrap="wrap"
        className={classes.addtionalFieldsChooseTitleContainer}
      >
        <Box className={classes.additionalFieldsContainer}>
          <Box display="flex" alignItems="flex-end">
            <Typography variant="h5" className={classes.additionalFieldsText}>
              Additional Fields
            </Typography>
            <Button
              className={classes.addButton}
              onClick={handleOpenAdditionalFields}
            >
              <AddCircleRoundedIcon color="secondary" />
            </Button>
          </Box>
          {org.additionalFields.map((field, i) => {
            const { name } = field
            return (
              <Box
                className={classes.additionalFieldContainer}
                key={i}
                display="flex"
                alignItems="center"
                justifyContent="space-between"
              >
                <Typography variant="subtitle2">{name}</Typography>
                <IconButton
                  color="primary"
                  onClick={() => {
                    handleOpenAdditionalFieldsFromEdit(field)
                  }}
                >
                  <EditIcon />
                </IconButton>
              </Box>
            )
          })}
        </Box>
        <Box className={classes.chooseTitleContainer}>
          <Typography className={classes.chooseTitleText} variant="h5">
            User Title
          </Typography>
          <Box>
            <FormControl className={classes.selectContainer}>
              <Select
                value={titleField ? titleField.id : -1}
                onChange={handleChangeSelect}
                className={classes.select}
              >
                <MenuItem className={classes.menuItemText} value={-1}>
                  None
                </MenuItem>
                {org.additionalFields.map((field, i) => {
                  const { name } = field
                  return (
                    <MenuItem
                      className={classes.menuItemText}
                      key={i}
                      value={field.id}
                    >
                      {name}
                    </MenuItem>
                  )
                })}
              </Select>
            </FormControl>
          </Box>
          {titleFieldId !== -1 && titleFieldId !== null && (
            <Box className={classes.exampleContainer}>
              <Typography
                variant="body1"
                className={classes.exmpleContainerTitle}
              >
                Sample View:
              </Typography>
              <Box display="flex">
                <Box>
                  <Avatar
                    className={classes.avatar}
                    src={cl.url(profileImage, {
                      width: 100,
                      crop: "scale"
                    })}
                  />
                </Box>
                <Box className={classes.rightExampleContainer}>
                  <Typography variant="subtitle2" className={classes.nameText}>
                    {`${firstName} ${lastName}`}
                  </Typography>
                  <Typography variant="body1" className={classes.grayText}>
                    {titleFieldId &&
                      org.additionalFields &&
                      getTitleFieldName(titleFieldId)}
                  </Typography>
                </Box>
              </Box>
            </Box>
          )}
        </Box>
      </Box>
      {isMobile && (
        <Box>
          <PostSettings org={org} />
          <IntegrationConnections />
        </Box>
      )}
      {!!org.hasStripe && (
        <Box className={classes.cancelSection}>
          <Typography className={classes.cancelHeading} variant="h5">
            Edit Card Information
          </Typography>
          <Typography className={classes.cancelCopy}>
            Change which card you use to pay for your FirstLine Social
            subscription.
          </Typography>
          <Box
            className={classes.buttonsContainer}
            display="flex"
            justifyContent="flex-start"
          >
            <Button
              color="primary"
              onClick={() => {
                setCardInfo(true)
              }}
              variant="contained"
            >
              edit card info
            </Button>
          </Box>
        </Box>
      )}
      <Box className={classes.cancelSection}>
        <Typography className={classes.cancelHeading} variant="h5">
          Cancel Subscription & Delete Organization
        </Typography>
        <Typography className={classes.cancelCopy}>
          Here you can cancel your subscription and delete your organization.
          You must remove all your organization's submitted and published posts
          before completing this action. This action cannot be undone.
        </Typography>
        <Box
          className={classes.buttonsContainer}
          display="flex"
          justifyContent="flex-start"
        >
          <Button
            style={{ background: "red" }}
            onClick={() => {
              dispatch(openDeleteOrgDialog())
            }}
            variant="contained"
          >
            cancel subscription
          </Button>
        </Box>
      </Box>
    </Box>
  )
}

export default withStyles(styles)(IntergrationTextFields)



// WEBPACK FOOTER //
// ./src/pages/Admin/pages/Settings/IntegrationTextFields/index.jsx